const routes = [
    {
        path: "/",
        name: "Home",
        component: () => import("../views/Analysis.vue")
    },
    {
        path: "/analysis",
        name: "Analysis",
        component: () => import("../views/Analysis.vue")
    },
    {
        path: "/analysis/notification",
        name: "SchemaFromNotification",
        component: () => import("../views/Analysis.vue")
    },
    {
        path: "/analysis/notification/:type/:notificationId/:entityType",
        name: "AnalysisFromNotificationsWithEntityType",
        component: () => import("../views/Analysis.vue")
    },
    {
        path: "/analysis/alert/:type",
        name: "AnalysisFromAlerts",
        component: () => import("../views/Analysis.vue")
    },
    {
        path: "/analysis/scenario/:scenarioId",
        name: "AnalysisFromScenarios",
        component: () => import("../views/Analysis.vue")
    },
    {
        path: "/management",
        name: "Management",
        component: () => import("../views/management/Management.vue")
    },
    {
        path: "/authorization",
        name: "Authorization",
        component: () => import("../views/management/Authorization.vue")
    },
    {
        path: "/scenarios",
        name: "Scenarios",
        component: () => import("../views/Scenarios.vue")
    },
    {
        path: "/knowYourCustomerList",
        name: "KnowYourCustomerList",
        component: () => import("../views/KnowYourCustomerList.vue")
    },
    {
        path: "/knowYourCustomerAnalysis/:queryId?",
        name: "KnowYourCustomer",
        component: () => import("../views/KnowYourCustomerAnalysis.vue")
    },
    {
        path: "/knowYourCustomerAlerts",
        name: "KnowYourCustomerAlert",
        component: () => import("../views/KnowYourCustomerAlerts.vue")
    },
    {
        path: "/knowYourCustomerAlarms",
        name: "knowYourCustomerAlarm",
        component: () => import("../views/KnowYourCustomerAlarms.vue")
    },
    {
        path: "/knowYourCustomerRfi",
        name: "knowYourCustomerRfi",
        component: () => import("../views/KnowYourCustomerRfis.vue")
    },
    {
        path: "/informationRequests",
        name: "InformationRequests",
        component: () => import("../views/InformationRequests.vue")
    },
    {
        path: "/knowYourCustomerAlarmManagement",
        name: "knowYourCustomerAlarmManagement",
        component: () => import("../views/KnowYourCustomerAlarmManagement.vue")
    },
    {
        path: "/scenariohistories",
        name: "ScenarioHistories",
        component: () => import("../views/ScenarioHistory.vue")
    },
    {
        path: "/autoAlertAssign",
        name: "AutoAlertAssign",
        component: () => import("../views/AutoAlertAssign.vue")
    },
    {
        path: "/casemanagement",
        name: "CaseManagement",
        component: () => import("../views/CaseManagement.vue")
    },
    {
        path: "/casedetail/:caseId/:type",
        name: "CaseDetail",
        component: () => import("../views/CaseDetail.vue")
    },
    {
        path: "/sibs",
        name: "Sibs",
        component: () => import("../views/Sibs.vue")
    },
    {
        path: "/analysisList",
        name: "AnalysisList",
        component: () => import("../views/AnalysisList.vue")

    },
    {
        path: "/autosavedSchemaList",
        name: "AutosavedSchemaList",
        component: () => import("../views/AutosavedSchemaList.vue")

    },
    {
        path: "/underConstruction",
        name: "UnderConstruction",
        component: () => import("../components/under-construction/UnderConstruction.component.vue")
    },
    //TODO furkan: sadece jandarma için Analysis kısmında çağırıldığı ve bu kısmında env Jandarma olduğunda çalışacağı için path kapatılmıştır. İleride ihtiyaca binaen Announcements.vue içerisinde img kısmı dinamik environment'e göre değiştirilebilir.
    // {
    //     path: "/announcements",
    //     name: "Announcements",
    //     component: () => import("../views/Announcements.vue")
    // },
    {
        path: "/tbistatistics",
        name: "TBIStatistics",
        component: () => import("../views/ThothBIStatistics.vue")
    },
    {
        path: "/intelligenceData",
        name: "IntelligenceData",
        component: () => import("../views/IntelligenceData.vue")
    },
    {
        path: "/dataBinding",
        name: "DataBinding",
        component: () => import("../views/DataBinding.vue")
    },
    {
        path: "/scenarioalerts",
        name: "ScenarioAlerts",
        component: () => import("../views/ScenarioAlerts.vue")
    },
    {
        path: "/writableEntityData",
        name: "WritableEntityData",
        component: () => import("../views/WritableEntityAllPage.vue")
    },
    {
        path: "/preparedqueries",
        name: "PreparedQueries",
        component: () => import("../views/PreparedQueryManagement.vue")
    },
    {
        path: "/plateTrackingSystem",
        name: "PlateTrackingSystem",
        component: () => import("../views/PlateTrackingSystem.vue")
    },
    {
        path: "/cfaAnalysis",
        name: "CfaAnalysis",
        component: () => import("../views/CfaAnalysis.vue")
    },
    {
        path: "/analysis/preparedquery/:preparedQueryId",
        name: "AnalysisFromPreparedQuery",
        component: () => import("../views/Analysis.vue")
    },
    {
        path: "/analysis/sibedit/:version/:sibId",
        name: "sibEdit",
        component: () => import("../views/Analysis.vue")
    },
    {
        path: "/importData",
        name: "ImportData",
        component: () => import("../views/ImportData.vue")
    },
    {
        path: "/analysis/sibfromalert",
        name: "SibFromAlert",
        component: () => import("../views/Analysis.vue")
    },
    {
        path: "/servicequery",
        name: "ServiceQuery",
        component: () => import("../views/ServiceQuery.vue")
    },
    {
        path: "/fraudListFiba",
        name: "FraudListFiba",
        component: () => import("../views/FraudListFiba.vue")
    },
    {
        path: "/reduceFalsePositive",
        name: "AI",
        component: () => import("../views/ArtificialIntelligent.vue")
    },
    {
        path: "/similarCustomer",
        name: "SimilarCustomer",
        component: () => import("../views/SimilarCustomer.vue")
    },
    {
        path: "/customerwarnings",
        name: "CustomerWarnings",
        component: () => import("../views/fiba-services/customer-warning/FibaCustomerWarnings.vue")
    },
    {
        path: "/trapphoneemail",
        name: "TrapPhoneEmail",
        component: () => import("../views/fiba-services/trap-phone-email/FibaTrapPhone.vue")
    },
    {
        path: "/trapemail",
        name: "TrapEmail",
        component: () => import("../views/fiba-services/trap-email/FibaTrapEmail.vue")
    },
    {
        path: "/accounthold",
        name: "AccountHold",
        component: () => import("../views/fiba-services/account-hold/FibaAccountHold.vue")
    },
    {
        path: "/customerchannelopenclose",
        name: "CustomerChannelOpenClose",
        component: () => import("../views/fiba-services/customer-channel-open-close/CustomerChannelOpenClose.vue")
    },
    {
        path: "/customerMonitoring",
        name: "customerMonitoring",
        component: () => import("../views/fiba-services/fiba-mail-services/FibaMailPage.vue")
    },
    {
        path: "/dtgraph",
        name: "DTGraph",
        component: () => import("../views/DTGraph.vue")
    },
    {
        path: "/sibTracking",
        name: "SibTracking",
        component: () => import("../views/SibTracking.vue")
    },
    {
        path: "/sibTrackingSdDescriptions",
        name: "SibTrackingSdDescriptions",
        component: () => import("../views/SibTrackingSdDescriptions.vue")
    },
    {
        path: "/sibTrackingRdDescriptions",
        name: "SibTrackingRdDescriptions",
        component: () => import("../views/SibTrackingRdDescriptions.vue")
    },
    {
        path: "/sibTrackingAlertStates",
        name: "SibTrackingAlertStates",
        component: () => import("../views/SibTrackingAlertStates.vue")
    },
    {
        path: "/sibDynamicDescription",
        name: "SibDynamicDescription",
        component: () => import("../views/SibDynamicDescription.vue")
    },
    {
        path: "/analysis/customerdetails/:customerEntity/:entityKey",
        name: "CustomerDetails",
        component: () => import("../views/Analysis.vue")
    },
    {
        path: "/spaceGraph",
        name: "SpaceGraph",
        component: () => import("../views/SpaceGraph.vue")
    },
];

export default routes;